import React from 'react';
import PropTypes from 'prop-types';
import { intlShape, injectIntl } from 'react-intl';
import styled from 'styled-components';

import messages from '../messages';

const StyledSpan = styled.span`
  color: ${({ theme }) => theme.colors.night_blue_2};
  ${({ theme }) => theme.fontFamily.secondaryFont.smallRegular};
  width: 80%;
  position: relative;
  display: block;
  text-align: left;
  margin-top: ${({ theme }) => theme.spaces.space_4};
  line-height: 18px;
`;

function MaxProductLabel({ productMaxQuantity, intl: { formatMessage } }) {
  return (
    <StyledSpan>
      {formatMessage(messages.product_quantity_text, {
        prodQuantity: productMaxQuantity,
      })}
    </StyledSpan>
  );
}

MaxProductLabel.propTypes = {
  productMaxQuantity: PropTypes.number,
  intl: intlShape.isRequired,
};

export default injectIntl(MaxProductLabel);
